import React, { useEffect, useState } from "react";
import styled, { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { Alert, Button, Grid, Link, Modal, Picture, Text } from "~/components-shared";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import api from "~/lib/api";
import VerifyCodeModal from "~/components/VerifyCodeModal";
import { handleError } from "~/lib/helpers";
import WorkingStyleCreateForm from "~/forms/WorkingStyleCreateForm";
import workingStyleCreateSchema from "~/forms/WorkingStyleCreateForm/workingStyleCreateSchema";
import Branding from "~/components/Branding";
import workingStyle from "~/assets/i/working-style.png";
import Footer from "~/components/Footer";
import qs from "qs";
import { useHistory, useLocation } from "react-router-dom";
import authActionCreators from "~/store/auth/actions";
import { RoutesEnum } from "~/types/enums";
import { useDispatch } from "react-redux";
import WorkingStyleAuthForm from "~/forms/WorkingStyleAuthForm";
import workingStyleAuthSchema from "~/forms/WorkingStyleAuthForm/workingStyleAuthSchema";
const Section = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
`;
const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  flex-grow: 1;
  margin: 0 auto;
  background-color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.misc.skyBlue;
}};
`;
const Content = styled.div`
  max-width: 1200px;
`;
const StyledGrid = styled(Grid)`
  min-height: 100%;
`;
const PublicWorkingStyles = () => {
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const [verifyCodeOpen, setVerifyCodeOpen] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    search
  } = useLocation();
  const {
    token
  } = qs.parse(search, {
    ignoreQueryPrefix: true
  });
  const [existingProfile, setExistingProfile] = useState(false);
  useEffect(() => {
    if (token) {
      dispatch(authActionCreators.updateTokenStarted(token));
      history.push(RoutesEnum.MY_WORKING_STYLE);
    }
  }, [token]);
  const {
    handleSubmit,
    watch,
    control
  } = useForm({
    resolver: yupResolver(existingProfile ? workingStyleAuthSchema : workingStyleCreateSchema),
    defaultValues: {
      firstName: "",
      email: ""
    }
  });
  const onSubmit = handleSubmit(_ref2 => {
    let {
      email
    } = _ref2;
    setIsLoading(true);
    api.validateWorkingStyleEmail(email).then(() => {
      setVerifyCodeOpen(true);
    }).catch(e => {
      setError(handleError(e));
    }).finally(() => {
      setIsLoading(false);
    });
  });
  const handleToggleProfile = () => {
    setExistingProfile(prev => !prev);
  };
  return /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(StyledGrid, {
    cols: 2,
    template: "1fr 2fr",
    equal: true,
    align: "center",
    s: {
      p: 7
    }
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Branding, {
    color: colors.background.primary,
    s: {
      mb: 30
    }
  }), /*#__PURE__*/React.createElement(Text, {
    element: "i",
    fontSize: 18,
    s: {
      mb: 12
    },
    display: "block"
  }, "\uD83E\uDE84"), /*#__PURE__*/React.createElement(Text, {
    color: colors.background.primary,
    element: "h1",
    s: {
      mb: 5
    }
  }, t("PublicWorkingStyles.title")), error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), existingProfile ? /*#__PURE__*/React.createElement(WorkingStyleAuthForm, {
    control: control
  }) : /*#__PURE__*/React.createElement(WorkingStyleCreateForm, {
    control: control
  }), /*#__PURE__*/React.createElement(Button, {
    color: "white",
    loading: isLoading,
    onClick: onSubmit,
    fontSize: 4,
    s: {
      px: 9,
      py: 3,
      mt: 5,
      mr: 5
    },
    display: "inline-block",
    rounded: true
  }, existingProfile ? t("PublicWorkingStyles.logIn") : t("common.actions.create")), /*#__PURE__*/React.createElement(Link, {
    color: "white",
    fontSize: 4,
    weight: "semiBold",
    onClick: handleToggleProfile,
    s: {
      mt: 5
    }
  }, existingProfile ? t("PublicWorkingStyles.createNewProfile") : t("PublicWorkingStyles.existingProfile"))), /*#__PURE__*/React.createElement(Picture, {
    color: "transparent",
    width: "100%",
    height: "80%",
    src: workingStyle
  }))), /*#__PURE__*/React.createElement(Modal, {
    open: verifyCodeOpen
  }, /*#__PURE__*/React.createElement(VerifyCodeModal, {
    firstName: watch("firstName"),
    email: watch("email"),
    onClose: () => setVerifyCodeOpen(false)
  }))), /*#__PURE__*/React.createElement(Footer, null));
};
export default PublicWorkingStyles;